import React, { useState } from "react"
import axios from "axios"
import { Badge, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import Table from "../../../../components/Table"
import ConfirmarEmailModal from "../../../../components/ConfirmarEmailModal"
import ConfirmDelete from "../../../../components/ConfirmDelete"
import auth from "../../../../utils/auth"
import cfg from "../../../../utils/config"
import helper from "../../../../utils/helper"
import { removerConfirmacaoEmail, verificarEmailConfirmado } from "../../../../services/confirmacaoEmail"

const REGEX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const Emails = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [count, setCount] = useState(0)
    const [next, setNext] = useState(null)
    const [previous, setPrevious] = useState(null)
    const [table, setTable] = useState(null)
    const [modalConfirmarEmail, setModalConfirmarEmail] = useState({ isOpen: false, email: null })

    const [modalEditarEmail, setModalEditarEmail] = useState({ isOpen: false, item: null })
    const [novoEmail, setNovoEmail] = useState("")
    const [erroEdicao, setErroEdicao] = useState("")
    const [salvandoEdicao, setSalvandoEdicao] = useState(false)
    const [modalConfirmarNovoEmail, setModalConfirmarNovoEmail] = useState({ isOpen: false, email: null })
    const [itemPendenteEdicao, setItemPendenteEdicao] = useState(null)

    const getData = (state) => {
        setLoading(true)
        const configMe = { headers: { Authorization: `Bearer ${auth.getToken()}` } }
        const userInfo = auth.getUserInfo()
        let url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/confirmacao-email/?limit=${state?.lineCount}` + state.filter

        if (state.url) {
            url = state.url
        }

        axios.get(url, configMe).then((res) => {
            setLoading(false)
            setData(res.data.results)
            setCount(res.data.count)
            setNext(res.data.next)
            setPrevious(res.data.previous)
        }).catch(() => setLoading(false))
    }

    const handleEmailConfirmado = () => {
        setModalConfirmarEmail({ isOpen: false, email: null })
        table?.fetch()
    }

    const removerConfirmacao = (email) => {
        removerConfirmacaoEmail(email).then(() => {
            helper.dispatchEvent("showAviso", { message: "Confirmação removida com sucesso." })
            table?.fetch()
        }).catch((error) => {
            helper.dispatchEvent("showAviso", { message: error?.response?.data?.detail || "Não foi possível remover a confirmação deste e-mail." })
        })
    }

    const abrirEdicao = (item) => {
        setNovoEmail(item.email)
        setErroEdicao("")
        setModalEditarEmail({ isOpen: true, item })
    }

    const aplicarNovoEmail = async (item, email) => {
        const userInfo = auth.getUserInfo()
        const baseUrl = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa
        const configMe = { headers: { Authorization: `Bearer ${auth.getToken()}` } }

        await Promise.all(item.origens.map(async (origem) => {
            if (origem.tipo === "usuario") {
                return axios.patch(`${baseUrl}/usuario/${origem.id}/`, { email }, configMe)
            }

            const clienteAtual = await axios.get(`${baseUrl}/cliente/${origem.id}/`, configMe)
            return axios.patch(`${baseUrl}/cliente/${origem.id}/`, {
                email_administrador: email,
                cpf_cnpj: clienteAtual.data.cpf_cnpj
            }, configMe)
        }))
    }

    const salvarEdicaoEmail = async () => {
        if (!REGEX_EMAIL.test(novoEmail)) {
            setErroEdicao("Digite um e-mail válido!")
            return
        }

        const item = modalEditarEmail.item
        setSalvandoEdicao(true)
        setErroEdicao("")

        try {
            const confirmado = await verificarEmailConfirmado(novoEmail)
            if (!confirmado) {
                setItemPendenteEdicao(item)
                setModalEditarEmail({ isOpen: false, item: null })
                setModalConfirmarNovoEmail({ isOpen: true, email: novoEmail })
                return
            }

            await aplicarNovoEmail(item, novoEmail)
            helper.dispatchEvent("showAviso", { message: "E-mail atualizado com sucesso." })
            setModalEditarEmail({ isOpen: false, item: null })
            table?.fetch()
        } catch (error) {
            const erros = error?.response?.data || {}
            setErroEdicao(erros.email?.[0] || erros.email_administrador?.[0] || erros.detail || "Não foi possível atualizar este e-mail.")
        } finally {
            setSalvandoEdicao(false)
        }
    }

    const handleNovoEmailConfirmado = async (email) => {
        const item = itemPendenteEdicao
        setModalConfirmarNovoEmail({ isOpen: false, email: null })
        setItemPendenteEdicao(null)

        try {
            await aplicarNovoEmail(item, email)
            helper.dispatchEvent("showAviso", { message: "E-mail atualizado com sucesso." })
            table?.fetch()
        } catch (error) {
            helper.dispatchEvent("showAviso", { message: error?.response?.data?.detail || "Não foi possível atualizar este e-mail." })
        }
    }

    const columns = [
        {
            Header: "E-mail",
            Accessor: "email",
            sortable: true
        },
        {
            Header: "Origem",
            Accessor: "origens",
            sortable: true,
            Cell: (original) => original.origens?.some((origem) => origem.tipo === "usuario") ? "Usuário" : "Cliente"
        },
        {
            Header: "Status",
            Accessor: "confirmado",
            sortable: false,
            Cell: (original) => (
                <Badge color={original.confirmado ? "success" : "danger"}>
                    {original.confirmado ? "Confirmado" : "Não confirmado"}
                </Badge>
            )
        },
        {
            Center: true,
            Header: "Ação",
            sortable: false,
            Cell: (original) => (
                <div className="clean-action" style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    {
                        original.confirmado
                            ? (
                                <ConfirmDelete
                                    enabled={true}
                                    label="Remover"
                                    modalTitle="Remover"
                                    modalMessage={<>Tem certeza que deseja remover a confirmação de <strong>{original.email}</strong>?<br />Esse e-mail deixará de estar apto a receber notificações até ser confirmado novamente.</>}
                                    action={() => removerConfirmacao(original.email)}
                                />
                            )
                            : (
                                <button
                                    className="hdv-btn-forms hdv-btn-green"
                                    onClick={() => setModalConfirmarEmail({ isOpen: true, email: original.email })}>
                                    Confirmar
                                </button>
                            )
                    }
                    <button
                        className="hdv-btn-forms hdv-btn-yellow"
                        onClick={() => abrirEdicao(original)}>
                        Editar
                    </button>
                </div>
            )
        }
    ]

    return (
        <div style={{ marginTop: "50px" }}>
            <Table
                notEditFirstColum
                data={data}
                loading={loading}
                count={count}
                next={next}
                previous={previous}
                columns={columns}
                onFetchData={getData}
                onUpdate={(tableInstance) => setTable(tableInstance)}
            />

            <ConfirmarEmailModal
                isOpen={modalConfirmarEmail.isOpen}
                email={modalConfirmarEmail.email}
                toggle={() => setModalConfirmarEmail({ isOpen: false, email: null })}
                onConfirmado={handleEmailConfirmado}
            />

            <Modal isOpen={modalEditarEmail.isOpen} toggle={() => setModalEditarEmail({ isOpen: false, item: null })}>
                <ModalHeader toggle={() => setModalEditarEmail({ isOpen: false, item: null })}>Editar E-mail</ModalHeader>
                <ModalBody>
                    <div className="hdv-form-default">
                        <label htmlFor="novo_email">Novo e-mail</label>
                        <input
                            type="text"
                            id="novo_email"
                            value={novoEmail}
                            disabled={salvandoEdicao}
                            onChange={(e) => { setNovoEmail(e.target.value); setErroEdicao("") }}
                        />
                        {erroEdicao && <span style={{ color: "#F44E3B", fontSize: "13px" }}>{erroEdicao}</span>}
                    </div>
                    <p style={{ fontSize: "13px", opacity: 0.8, marginTop: "10px" }}>
                        Isso atualiza o e-mail em {modalEditarEmail.item?.origens?.length > 1 ? "todos os cadastros" : "todo cadastro"} associado a <strong>{modalEditarEmail.item?.email}</strong>. Se o novo e-mail ainda não estiver confirmado, será solicitado o código de confirmação antes de salvar.
                    </p>
                </ModalBody>
                <ModalFooter>
                    <button className="hdv-btn-forms hdv-btn-default" onClick={() => setModalEditarEmail({ isOpen: false, item: null })}>Cancelar</button>
                    <button className="hdv-btn-forms hdv-btn-green" disabled={salvandoEdicao} onClick={salvarEdicaoEmail}>
                        {salvandoEdicao ? "Salvando..." : "Salvar"}
                    </button>
                </ModalFooter>
            </Modal>

            <ConfirmarEmailModal
                isOpen={modalConfirmarNovoEmail.isOpen}
                email={modalConfirmarNovoEmail.email}
                toggle={() => { setModalConfirmarNovoEmail({ isOpen: false, email: null }); setItemPendenteEdicao(null) }}
                onConfirmado={handleNovoEmailConfirmado}
            />
        </div>
    )
}

export default Emails
